const SET_COMPANY = "SET_COMPANY";
const SET_COMPANY_ID = "SET_COMPANY_ID";
const LOGIN = "LOGIN";

export {
    SET_COMPANY,
    SET_COMPANY_ID,
    LOGIN
}